import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { db } from "../Firebase";
import {
  doc,
  getDoc,
  collection,
  getDocs,
  query,
  where
} from "firebase/firestore";
import "../styles/TeacherCourseDetails.css";

const TeacherCourseDetails = () => {
  const { courseId } = useParams();
  const navigate = useNavigate();

  const [course, setCourse] = useState(null);
  const [videos, setVideos] = useState([]);
  const [orders, setOrders] = useState([]);
  const [totalStudentsAll, setTotalStudentsAll] = useState(0);
  const [totalRevenueAll, setTotalRevenueAll] = useState(0);
  const [loading, setLoading] = useState(true);
  const sampleVideo = videos.find(v => v.isSample);
  const courseVideos = videos.filter(v => !v.isSample);


  useEffect(() => {
    const loadData = async () => {
      try {
        /* ---------- COURSE ---------- */
        const courseSnap = await getDoc(
          doc(db, "courses", courseId)
        );

        if (!courseSnap.exists()) {
          navigate("/teacherCourse");
          return;
        }

        const data = courseSnap.data();
        setCourse({ id: courseSnap.id, ...data });

        /* ---------- VIDEOS ---------- */
        const videoSnap = await getDocs(
          collection(db, "courses", courseId, "videos")
        );

        setVideos(data.videos || []);

        /* ---------- ORDERS (COURSE) ---------- */
        const courseOrdersSnap = await getDocs(
          query(
            collection(db, "orders"),
            where("courseId", "==", courseId)
          )
        );

        const courseOrders = courseOrdersSnap.docs.map(d => d.data());
        setOrders(courseOrders);

        /* ---------- ALL ORDERS ---------- */
        const allOrdersSnap = await getDocs(collection(db, "orders"));

        let revenueAll = 0;
        allOrdersSnap.docs.forEach(d => {
          revenueAll += d.data().pricePaid || 0;
        });

        setTotalStudentsAll(allOrdersSnap.size);
        setTotalRevenueAll(revenueAll);
      } catch (err) {
        console.error(err);
        navigate("/teacherCourse");
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [courseId, navigate]);

  if (loading)
    return <p style={{ padding: 40 }}>Loading...</p>;

  //const sampleVideo = videos.find(v => v.isSample);
  //const courseVideos = videos.filter(v => !v.isSample);

  const courseStudents = orders.length;
  const courseRevenue = orders.reduce(
    (sum, o) => sum + (o.pricePaid || 0),
    0
  );

  const discountedPrice =
    course.isFree
      ? 0
      : course.discountPercent
      ? course.discountedPrice
      : course.price;

  return (
    <div className="teacher-course-page">

      {/* COURSE TOP */}
      <section className="course-top sec-card">
        <img
          src={course.thumbnail}
          alt=""
          className="course-thumb"
        />

        <div className="course-info">
          <h1>{course.title}</h1>
          <p>{course.description}</p>

          <div className="course-meta-grid">
            <div>
              <span>Category</span>
              <b>{course.category}</b>
            </div>

            <div>
              <span>Duration</span>
              <b>{course.duration}</b>
            </div>

            <div>
              <span>Price</span>
              <b>₹{course.price}</b>
            </div>

            <div>
              <span>Discount</span>
              <b>{course.discountPercent || 0}%</b>
            </div>

            <div>
              <span>Final Price</span>
              <b className="highlight">
                ₹{discountedPrice}
              </b>
            </div>
          </div>
        </div>
      </section>

      {/* PURCHASE DETAILS */}
      <section className="sec-card">
        <h2>Purchase Details</h2>

        <div className="stats-grid">
          <div>
            <span>Students (This Course) : </span>
            <b>{courseStudents}</b>
          </div>

          <div>
            <span>Revenue (This Course) : </span>
            <b>₹{courseRevenue}</b>
          </div>

          <div>
            <span>Total Students : </span>
            <b>{totalStudentsAll}</b>
          </div>

          <div>
            <span>Total Revenue : </span>
            <b>₹{totalRevenueAll}</b>
          </div>
        </div>
      </section>

      {/* SAMPLE VIDEO */}
      <section className="sec-card">
        <h2>Sample Video</h2>

        {sampleVideo ? (
          <div className="video-card">
            <video controls src={sampleVideo.url} />
            <h4>{sampleVideo.title}</h4>
            <p>{sampleVideo.description}</p>
          </div>
        ) : (
          <p>No sample video.</p>
        )}
      </section>

      {/* COURSE VIDEOS */}
      <section className="sec-card">
        <h2>Course Videos</h2>

        {courseVideos.map((v, i) => (
          <div key={v.id} className="video-card">
            <video controls src={v.url} />
            <h4>{i + 1}. {v.title}</h4>
            <p>{v.description}</p>
          </div>
        ))}
      </section>


      {/* FAQ */}
      <section className="sec-card">
        <h2>FAQ</h2>

        {course.faqs?.length > 0 ? (
          course.faqs.map((f, i) => (
            <div key={i} className="faq-item">
              <h4>{f.q}</h4>
              <p>{f.a}</p>
            </div>
          ))
        ) : (
          <p>No FAQ added.</p>
        )}
      </section>

      <button
        className="back-btn"
        onClick={() => navigate("/teacherCourse")}
      >
        ← Back
      </button>
    </div>
  );
};

export default TeacherCourseDetails;
